import { createContext } from "react";
const QuestionMasterContext = createContext();
export default QuestionMasterContext;

